import shipmentBatchComponent from './shipment_batch.component';
import ShipmentRecordModule from './shipment_record';
import PrintBatchModule from './print'

let shipmentBatchModule = angular.module('shipmentBatch', [
    ShipmentRecordModule,
    PrintBatchModule
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/shipmentBatch');

    $stateProvider
      .state('shipmentBatch', {
        url: '/shipment-batch',
        component: 'shipmentBatch',
        data: {
          requireLogin: true,
          requireACL: 'shipment_batch.all'          
        },
        parent: 'app',
      });
  })

  .component('shipmentBatch', shipmentBatchComponent)

  .name;

export default shipmentBatchModule;


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/index.js